export const SAFETYCODELOG_LIST_REQUEST = 'SAFETYCODELOG_LIST_REQUEST';
